/*Package importing*/
import React from 'react';

/*Import custom components and assets*/
import H6 from '../../components/heading/h6';
import service from '../../services/service';

const FaqModal = () => {
    return (
        <div className="modal fade e-modal-wrap e-faq-modal" id="faq-modal" tabIndex="-1" role="dialog" aria-labelledby="unBlockModalLabel" aria-hidden="true">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className='modal-header'>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <iframe
                        src="https://www.zappit.software/faq.html"
                        className="w-full h-full border-0"
                        title="FAQ"
                    ></iframe>
                </div>
            </div>
        </div>
    );
};

export default FaqModal;
